module.exports = __webpack_public_path__ + "static/img/image@2x (10).1931f31f.png";